module.exports = __webpack_public_path__ + "img/1.bab471c0.svg";